/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
import 'swiper/css';

import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
	const sliders = document.querySelectorAll('.swiper');

	sliders.forEach((slider) => {
		new Swiper(slider, {
			slidesPerView: 4,
			spaceBetween: 16,
			breakpoints: {
				1024: { slidesPerView: 2 },
				640: { slidesPerView: 1 },
			},
			loop: false,
			pagination: {
				el: slider.querySelector('.swiper-pagination'),
				clickable: true,
			},
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
		});
	});
});
